import { css } from '@emotion/react';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import prodPathReplace from 'shared/prod-path-rewrite';
import { getProgramDatesText } from 'athena/components/program-header/program-dates';
import { threeQuartersSpacing } from 'styles/global_defaults/scaffolding';


type FlyerHeaderProps = {
  roleAlias: string;
  programName: string;
  programDescription?: string;
  releasedDate?: string;
  endDate?: string;
};

const FlyerHeader = ({
  roleAlias,
  programName,
  programDescription,
  releasedDate,
  endDate,
}: FlyerHeaderProps) => {
  const styles = css`
    // TODO: I think that this is actually not the correct background image. Confirm with design
    background: url('${prodPathReplace('images/program-guide-bg.svg')}');
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .badge {
      border-radius: 18px;
      padding: 7.5px ${threeQuartersSpacing}px;
    }
  `;

  return (
    <div className='d-flex flex-column align-items-center p-5' css={styles}>
      <div className='badge text-small bold color-black bg-color-yellow'>{t.MENTORING_PROGRAMS.FLYER.NOW_ACCEPTING(roleAlias)}</div>
      <div className='heading-1 mt-3'>{programName}</div>
      <div className='text-large-body color-gray-1 mt-3'>{programDescription}</div>
      <div className='d-flex align-items-center mt-3'>
        <NvIcon icon='calendar' size='xs-smallest' className='mr-1 color-gray-3' />
        <span className='color-gray-1'>{getProgramDatesText(releasedDate, endDate)}</span>
      </div>
    </div>
  );
};

export default FlyerHeader;
